import Vue from "vue"
import moment from "moment"

Vue.filter("localeString", (value: number) => {
  if (!value) return 0
  return value.toLocaleString("pt-br")
})

Vue.filter("moment", (value: string, format: string) => {
  if (!value) return moment().format(format || "DD/MM/YYYY")
  return moment(value).format(format || "DD/MM/YYYY")
})

Vue.filter("process_name", (value: any) => {
  if (!value) return "Sem processo"
  return `${value?.process_id} - ${value?.name || ""} ${
    value?.process?.name?.toLowerCase() == value?.name?.toLowerCase()
      ? ""
      : value?.process?.name || ""
  }`
})
